import { Box, Grid, TextField, Button, CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { MemberMetaData } from '../../api/models/member';
import { BasicDropDown } from '../../shared/basicDropDown';
import { DropDownItem, gradeClassList } from '../../models/dropDownItemViewModel';
import { useMemberContext } from '../../context/memberContext';

export interface MemberFormMetaData {
    nickName: string,
    seasonsExp: string,
    school: string,
    height: string,
    weight: string,
    birthplace: string,
    hobby: string,
    favoriteTeam: string,
    favoriteSubject: string,
    occupation: string,
    favoritePosition: string,
    uniqueFact: string,
    gradeClass: string,
}



const defaultMetaData = {
    "nickName": '',
    "seasonsExp": '',
    "school": '',
    "height": '',
    "weight": '',
    "birthplace": '',
    "hobby": '',
    "favoriteTeam": '',
    "favoriteSubject": '',
    "occupation": '',
    "favoritePosition": '',
    "uniqueFact": '',
    "gradeClass": ''
}


export default function MemberCardDataTab() {

    const [metaData, setMetaData] = React.useState<MemberFormMetaData>(defaultMetaData);
    const { isAuthenticated} = useAuth0();

    const { member, isLeader, updateMetaData, isLoadingMetaData} = useMemberContext();

    useEffect(() => {   
        if (member && member.metaData) {
            setMetaData({nickName: member.metaData.nickName ?? '',
                seasonsExp: member.metaData.seasonsExp?.toString() ?? '',
                school: member.metaData.school ?? '',
                height: member.metaData.height ? member.metaData.height.toString() : '',
                weight: member.metaData.weight ? member.metaData.weight.toString() : '',
                birthplace: member.metaData.birthplace ?? '',
                hobby: member.metaData.hobby ?? '',
                favoriteTeam: member.metaData.favoriteTeam ?? '',
                favoriteSubject: member.metaData.favoriteSubject ?? '', 
                occupation: member.metaData.occupation ?? '',
                favoritePosition: member.metaData.favoritePosition ?? '',
                uniqueFact: member.metaData.uniqueFact ?? '',
                gradeClass: member.metaData.gradeClass ?? ''});
        }
        else{
            setMetaData(defaultMetaData);
        }
    }, [member]);


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setMetaData({ ...metaData, [id]: value });
    };

    const handleGradeClassChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const gradeClass = e.target.value;
        setMetaData({ ...metaData, 'gradeClass': gradeClass });
    };

    const handleHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const height = e.target.value;
        setMetaData({ ...metaData, 'height': height });
    };

    const handleUpdateMetaData = async () => {

        const updatedMetaData: MemberMetaData = {
            nickName: metaData.nickName,
            seasonsExp: metaData.seasonsExp ? parseInt(metaData.seasonsExp) : undefined,
            school: metaData.school,
            height: metaData.height ? parseInt(metaData.height) : undefined,
            weight: metaData.weight ? parseInt(metaData.weight) : undefined,
            birthplace: metaData.birthplace,
            hobby: metaData.hobby,
            favoriteTeam: metaData.favoriteTeam,
            favoriteSubject: metaData.favoriteSubject,
            occupation: metaData.occupation,
            favoritePosition: metaData.favoritePosition,
            uniqueFact: metaData.uniqueFact,
            gradeClass: metaData.gradeClass
        };

        updateMetaData(updatedMetaData);
    };

    return (
        <Box>
        <Grid container spacing={1}>

            <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="nickName"
                        label="NickName"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.nickName}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="school"
                        label="School"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.school}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="birthplace"
                        label="Birthplace"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.birthplace}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="hobby"
                        label="Hobby"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.hobby}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="favoriteTeam"
                        label="FavoriteTeam"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.favoriteTeam}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>

            {!isLeader && <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="seasonsExp"
                        label="Seasons Experience"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.seasonsExp}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>}

            {!isLeader && <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="height"
                        label="Height"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.height}
                        style={{ width: 275 }}
                        onChange={handleHeightChange} />
                </Box>
            </Grid>}

            {!isLeader && <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="weight"
                        label="Weight"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.weight}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
                </Grid>}

                {!isLeader && <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="favoriteSubject"
                        label="FavoriteSubject"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.favoriteSubject}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>}

            {!isLeader && <Grid item xs={12} sm={4}>
                <Box>
                    <TextField id="occupation"
                        label="Dream Job"
                        variant="outlined"
                        size="small"
                        helperText='20 character limit'
                        inputProps={{ maxLength: 20 }}
                        value={metaData.occupation}
                        style={{ width: 275 }}
                        onChange={handleInputChange} />
                </Box>
            </Grid>}

            {!isLeader && <Grid item xs={12} sm={4}>
                <Box>

                <BasicDropDown id='gradeClass'
                    label='select grade'
                    width={275}
                    value={metaData.gradeClass}
                    items={gradeClassList}
                    onChange={handleGradeClassChange} />
                </Box>
            </Grid>}

            </Grid>

            
                <Box>
                    <TextField id="uniqueFact"
                        label="Unique Fact"
                        variant="outlined"
                        size="small"
                        helperText='40 character limit'
                        inputProps={{ maxLength: 55 }}
                        value={metaData.uniqueFact}
                        style={{ width: 500 }}
                        onChange={handleInputChange} />
                </Box>
            

            
                {isAuthenticated && !isLoadingMetaData && <Button variant='contained' onClick={handleUpdateMetaData}>Update MetaData</Button>}
                {isLoadingMetaData && <CircularProgress />}
            
                </Box>
    )
}